module.exports = __webpack_public_path__ + "static/3-f77906356ddcf577a609330c447fa380.jpg";